<avi-component-adder
    class="match-adder sel-match-adder"
    [options]="selectableOptions"
    [selectedComponents]="selectedOptions"
    [disableAdd]="disableAddButton"
    (onAdd)="addMatch($event)"
    noAvailableOptionsLabel="{{ l10nKeys.noAvailableMatchesLabel | vtranslate }}"
    addLabel="{{ globalL10nKeys.addLabel | vtranslate }}"
    noSelectedComponentsLabel="{{ l10nKeys.noEntriesLabel | vtranslate }}"
></avi-component-adder>
